export default __webpack_public_path__ + "static/media/Do not sign.1374226c.svg";